var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "60%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-text-field", {
                staticClass: "ml-5 mr-5 mb-0",
                attrs: { label: "Key", outlined: "" },
                model: {
                  value: _vm.keyName,
                  callback: function ($$v) {
                    _vm.keyName = $$v
                  },
                  expression: "keyName",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-textarea", {
                staticClass: "ml-5 mr-5 mt-0",
                attrs: { label: "Value", outlined: "" },
                model: {
                  value: _vm.valueName,
                  callback: function ($$v) {
                    _vm.valueName = $$v
                  },
                  expression: "valueName",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonLoading, color: "primary" },
                  on: { click: _vm.onPressUse },
                },
                [_vm._v("CREATE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }